module.exports = __webpack_public_path__ + "static/img/book2.a5111bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book2.png
// module id = gZBq
// module chunks = 1